import BaseError, { ErrorProps } from './BaseError';

export function Error404(props: ErrorProps) {
  return (
    <BaseError
      description="The page you're looking for doesn't exist or has been moved."
      title="Page Not Found"
      {...props} />
  );
}
